import React, { useEffect } from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from 'react-router-dom';
import { DarkModeProvider } from './context/DarkModeContext/darkModeContext';
import Soon from './views/Soon/Soon';
import HeroSection from './views/HeroSection/HeroSection';
import Services from './views/Services/Services';
import About from './views/About/About';
import Contact from './views/Contact/Contact';
import Products from './views/Products/Products';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import "animate.css/animate.compat.css";
import Snowfall from 'react-snowfall';

// Import the Navbar component
import Navbar from './components/Navbar/Navbar';

// Google Analytics Tracking ID
const TRACKING_ID = "G-CRMMNN1LGZ";

// Google Tag Manager ID
const GTM_ID = "GTM-M3GZMPLB";

function App() {
  return (
    <Router>
      <DarkModeProvider>
        <ScrollToTop />
        <AnalyticsTracker /> {/* Track GA & GTM */}
        <AppContent />
      </DarkModeProvider>
    </Router>
  );
}

// Component to initialize GTM & track GA4 page views
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics (GA4)
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send({ hitType: "pageview", page: location.pathname });

    // Initialize Google Tag Manager (GTM)
    TagManager.initialize({ gtmId: GTM_ID });

    // Send a page view event to GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page: location.pathname,
    });

  }, [location]); // Runs every time route changes

  return null;
}

function AppContent() {
  const location = useLocation();

  return (
    <>
      {location.pathname !== '/soon' && <Navbar />}
      <Routes>
        <Route path="/soon" element={<Soon />} />
        {/* <Route path="/" element={<HeroSection />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} /> */}
        
        {/* Redirect all other routes to "/soon" */}
        <Route path="*" element={<Navigate to="/soon" replace />} />
      </Routes>
    </>
  );
}

export default App;
